import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { machineMaintenanceReducer } from './reducers';
import { machineMaintenanceEffects } from './effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forRoot(machineMaintenanceReducer),
    EffectsModule.forRoot(machineMaintenanceEffects),
    StoreDevtoolsModule.instrument({ maxAge: 10 }),
  ],
  providers: [],
})
export class ReduxStoreModule {}
